<div class="header-wraper" style="width: 100%; display: flex; height: 55px">
  <nav
    style="width: 90%; float: left; margin: 10px 0px"
    class="navbar navbar-expand-lg headerContainer mb-3"
  >
    <a class="navbar-brand d-flex">
      <img
        alt=""
        src="../../../assets/images/5_image.jpg"
        style="width: 50px; padding: 0px 5px"
      />

      <div class="logoTxt">
        <strong>AI Analytics</strong>
        <span>Process Automation </span>
      </div>
    </a>
  </nav>
  <span
    style="
      width: 10%;
      justify-content: end;
      padding: 15px;
      display: inline-flex;
      height: 55px;
      align-items: center;
    "
  >
    <div class="dropdown">
      <button
        class="btn dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {{ loginedUserDetails?.username }}
      </button>
      <ul class="dropdown-menu">
        <li (click)="clearStorage()" (keydown.enter)="clearStorage()">
          <a class="dropdown-item"
            ><i
              class="fa fa-sign-out nav-icons-dropdown"
              aria-hidden="true"
            ></i>
            &nbsp;&nbsp;Logout</a
          >
        </li>
      </ul>
    </div>
  </span>
</div>
@if (bodySpinner) {
  <div class="access-loader"></div>
}
<div class="page-title">
  <span class="d-flex justify-content-center w-97"
    ><h4>AI Analytics, Summarization, and Process Automation</h4></span
  >
  @if (["admin", "super admin"].includes($safeNavigationMigration(loggedInRole?.toLowerCase()))) {
    <span
      class="icon user-management-icon"
      (click)="OpenModel('user-privilege')"
      (keydown.enter)="OpenModel('user-privilege')"
    >
      <i class="user-privilege"></i>
      <span class="tooltip-text">User Management</span>
    </span>
  }
</div>
@if (!bodySpinner) {
  <div class="apps-wrapper">
    @if (spinner) {
      <span> <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></span>
    }
    <div class="d-flex align-items-center justify-content-center list-apps">
      <div class="list">
        @if (isAllowed("Call")) {
          <div
            class="card"
            (click)="selectedApps('audio')"
            (keydown.enter)="selectedApps('audio')"
          >
            <div class="card-body">
              <div class="d-flex justify-content-center">
                <span class="call-app-icon">
                  <i class="bi bi-headset"></i>
                </span>
              </div>
              <p class="card-text">Post Call</p>
            </div>
          </div>
        }
        @if (isAllowed("VoiceMail")) {
          <div
            class="card"
            (click)="selectedApps('voiceMail')"
            (keydown.enter)="selectedApps('voiceMail')"
          >
            <div class="card-body">
              <div class="d-flex justify-content-center">
                <span class="call-app-icon">
                  <i class="bi bi-voicemail"></i>
                </span>
              </div>
              <p class="card-text">Voice Mail</p>
            </div>
          </div>
        }
        @if (isAllowed("IVR")) {
          <div
            class="card"
            (keydown.enter)="selectedApps('ivr')"
            (click)="selectedApps('ivr')"
            (keydown.enter)="selectedApps('ivr')"
          >
            <div class="card-body">
              <div class="d-flex justify-content-center">
                <span class="call-app-icon">
                  <i class="bi bi-soundwave"></i>
                </span>
              </div>
              <p class="card-text">IVR</p>
            </div>
          </div>
        }
        @if (isAllowed("Email")) {
          <div
            class="card"
            (click)="selectedApps('email')"
            (keydown.enter)="selectedApps('email')"
          >
            <div class="card-body">
              <div class="d-flex justify-content-center">
                <span class="call-app-icon">
                  <i class="bi bi-envelope-open"></i>
                </span>
              </div>
              <p class="card-text">E-mail</p>
            </div>
          </div>
        }
        @if (isAllowed("Survey")) {
          <div
            class="card"
            (click)="selectedApps('survey')"
            (keydown.enter)="selectedApps('survey')"
          >
            <div class="card-body">
              <div class="d-flex justify-content-center">
                <span class="call-app-icon">
                  <i class="bi bi-graph-up-arrow"></i>
                </span>
              </div>
              <p class="card-text">Survey</p>
            </div>
          </div>
        }
      </div>
      <div class="list">
        @if (isAllowed("Text")) {
          <div
            class="card"
            (click)="selectedApps('text')"
            (keydown.enter)="selectedApps('text')"
          >
            <div class="card-body">
              <div class="d-flex justify-content-center">
                <span class="call-app-icon">
                  <i class="bi bi-file-text"></i>
                </span>
              </div>
              <p class="card-text">Text</p>
            </div>
          </div>
        }
        @if (isAllowed("Document")) {
          <div
            class="card"
            (click)="selectedApps('document')"
            (keydown.enter)="selectedApps('document')"
          >
            <div class="card-body">
              <div class="d-flex justify-content-center">
                <span class="call-app-icon">
                  <i class="bi bi-file-earmark"></i>
                </span>
              </div>
              <p class="card-text">Document</p>
            </div>
          </div>
        }
        @if (isAllowed("Contract")) {
          <div
            class="card"
            (click)="selectedApps('contract')"
            (keydown.enter)="selectedApps('contract')"
          >
            <div class="card-body">
              <div class="d-flex justify-content-center">
                <span class="call-app-icon">
                  <i class="contract-hand"></i>
                </span>
              </div>
              <p class="card-text">Contract</p>
            </div>
          </div>
        }
        @if (isAllowed("RFP")) {
          <div
            class="card"
            (click)="selectedApps('rfpcontract')"
            (keydown.enter)="selectedApps('rfpcontract')"
          >
            <div class="card-body">
              <div class="d-flex justify-content-center">
                <span class="call-app-icon">
                  <i class="contract"></i>
                </span>
              </div>
              <p class="card-text">RFP</p>
            </div>
          </div>
        }
        @if (isAllowed("InfoSec")) {
          <div
            class="card"
            (click)="selectedApps('infosecurity')"
            (keydown.enter)="selectedApps('infosecurity')"
          >
            <div class="card-body">
              <div class="d-flex justify-content-center">
                <span class="call-app-icon">
                  <i class="bi bi-shield-lock"></i>
                </span>
              </div>
              <p class="card-text">Information Security</p>
            </div>
          </div>
        }
        @if (isAllowed("SocialMedia")) {
          <div
            class="card"
            (click)="selectedApps('social-media')"
            (keydown.enter)="selectedApps('social-media')"
          >
            <div class="card-body">
              <div class="d-flex justify-content-center">
                <span class="call-app-icon">
                  <i class="social-media"></i>
                </span>
              </div>
              <p class="card-text">Social Media</p>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-center list-apps">
      <div class="list"></div>
    </div>
    <div style="width: 100%; background: #c3c3c3; height: 1px"></div>
    <div class="d-flex align-items-center justify-content-center list-apps">
      <div class="list">
        @if (isAllowed("AIAssistance")) {
          <div
            class="card"
            (click)="selectedApps('ai-assist')"
            (keydown.enter)="selectedApps('ai-assist')"
          >
            <div class="card-body">
              <div class="d-flex justify-content-center">
                <span class="call-app-icon">
                  <i class="fa fa-robot"></i>
                </span>
              </div>
              <p class="card-text">AI Assistance</p>
            </div>
          </div>
        }
        @if (isAllowed("Reports")) {
          <div
            class="card"
            (click)="selectedApps('reports')"
            (keydown.enter)="selectedApps('reports')"
          >
            <div class="card-body">
              <div class="d-flex justify-content-center">
                <span class="call-app-icon">
                  <i class="custom-report"></i>
                </span>
              </div>
              <p class="card-text">BI Reports and Analytics</p>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
<app-dialog-modal
  [isVisible]="isModalVisible"
  [popLoader]="popLoader"
  [size]="metricFullscreen ? 'full-screen' : 'large'"
>
  <div modal-header class="modal-header ai-logo">
    <h4 class="modal-title">User Apps Privilege</h4>
    <span>
      <i
        class="fa metricFullscreen"
        [ngClass]="{
          'fa-down-left-and-up-right-to-center': metricFullscreen,
          'fa-up-right-and-down-left-from-center': !metricFullscreen,
        }"
        (click)="metricFullscreen = !metricFullscreen"
        (keydown.enter)="metricFullscreen = !metricFullscreen"
      ></i
      >&nbsp;&nbsp;
      <i
        class="fa-solid fa-xmark exitIcon"
        #closebutton
        data-bs-dismiss="modal"
        aria-label="Close"
        (click)="closeModal()"
        (keydown.enter)="closeModal()"
      ></i>
    </span>
  </div>
  <div modal-body class="modal-body">
    <div class="left-panel">
      <div
        class="position-relative px-1 py-1 d-flex flex-row align-items-center"
      >
        <span class="search-wrapper">
          <span class="icon"><i class="fa-solid fa-magnifying-glass"></i></span>
          <input
            type="text"
            [(ngModel)]="listSearch"
            autocomplete="off"
            placeholder="Search user"
            class="form-control audioTableSearchInput"
            name="searchInput"
            id="searchInput"
          />
          <span
            class="icon"
            (click)="listSearch = ''"
            (keydown.enter)="listSearch = ''"
          >
            @if (listSearch) {
              <i class="fa-solid fa-xmark"></i>
            }
          </span>
        </span>
        <button
          class="btn new-btn"
          (click)="newUser()"
          (keydown.enter)="newUser()"
          pTooltip="Add New User"
        >
          +
        </button>
      </div>

      <div class="position-relative">
        <ul
          class="list-items-v"
          appScrollNearEnd
          [threshold]="2"
          (nearEnd)="onNearEndScroll()"
        >
          @for (
            user of userListData | filter: listSearch : "username";
            track user.id
          ) {
            <li
              (click)="selectUser(user)"
              (keydown.enter)="selectUser(user)"
              [class.active]="userselectedId == user.id"
            >
              <span>{{ user?.username }}</span>
              <span>{{ user?.email }}</span>
            </li>
          }
        </ul>
      </div>
    </div>
    <div class="right-panel">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4><b>User Detail</b></h4>
        @if (userselectedId) {
          <div class="d-flex align-items-center action-btns">
            @if (
              !userDetailInput?.is_active &&
              ["admin", "super admin"].includes($safeNavigationMigration(loggedInRole?.toLowerCase()))
            ) {
              <button
                type="button"
                class="btn status-btn activate-btn"
                (click)="deactivateUserFun(userDetailInput)"
                (keydown.enter)="deactivateUserFun(userDetailInput)"
              >
                <i class="fa fa-check" aria-hidden="true"></i>&nbsp;Activate
              </button>
            }
            @if (
              userDetailInput?.is_active &&
              ["admin", "super admin"].includes($safeNavigationMigration(loggedInRole?.toLowerCase()))
            ) {
              <button
                type="button"
                class="btn status-btn deactivate-btn"
                (click)="deactivateUserFun(userDetailInput)"
                (keydown.enter)="deactivateUserFun(userDetailInput)"
              >
                <i class="fa fa-ban" aria-hidden="true"></i>&nbsp;Deactivate
              </button>
            }
            @if (
              ["admin", "super admin"].includes($safeNavigationMigration(loggedInRole?.toLowerCase()))
            ) {
              <button
                type="button"
                class="btn status-btn delete-btn"
                (click)="deleteUserFun(userDetailInput)"
                (keydown.enter)="deleteUserFun(userDetailInput)"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>&nbsp;Delete
              </button>
            }
          </div>
        }
      </div>
      <div class="d-flex flex-column">
        @if (spinner) {
          <span> <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></span>
        }

        <form [formGroup]="userForm" autocomplete="off">
          <div class="row">
            <div class="col">
              <div class="">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="username" class="form-label mandatoryLabel"
                        >User Name
                        <i class="fa-solid fa-asterisk mandatoryIcon"></i
                      ></label>
                      <input
                        type="text"
                        TrimText
                        class="form-control"
                        formControlName="username"
                        name="username"
                        placeholder="Enter user name"
                      />
                      @if (
                        submitted && userForm.hasError("required", "username")
                      ) {
                        <span class="text-danger">
                          User name is required.
                        </span>
                      }
                      @if (
                        submitted && userForm.hasError("pattern", "username")
                      ) {
                        <span class="text-danger">
                          Invalid input: Only special characters (space, &,
                          comma, -) are allowed.
                        </span>
                      }
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="role" class="form-label mandatoryLabel"
                        >User Role
                        <i class="fa-solid fa-asterisk mandatoryIcon"></i
                      ></label>

                      <ng-select
                        placeholder="Select"
                        [multiple]="false"
                        formControlName="role"
                        name="role"
                        class="transcribeClass"
                      >
                        @for (role of roleList; track role.id) {
                          @if (role.is_active) {
                            <ng-option
                              value="{{ role.name }}"
                              [disable]="
                                ['super admin'].includes(
                                  $safeNavigationMigration(role.name?.toLowerCase())
                                )
                              "
                              >{{ role.name }}</ng-option
                            >
                          }
                        }
                      </ng-select>

                      @if (submitted && userForm.hasError("required", "role")) {
                        <span class="text-danger">
                          User role is required.
                        </span>
                      }
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        for="email"
                        class="form-label mandatoryLabel"
                        [ngClass]="{
                          'is-invalid': submitted && f['email'].errors,
                        }"
                        >Email <i class="fa-solid fa-asterisk mandatoryIcon"></i
                      ></label>
                      <input
                        type="email"
                        class="form-control"
                        formControlName="email"
                        name="email"
                        id="email"
                        placeholder="example@gmail.com"
                      />
                      @if (submitted && f["email"].errors) {
                        <div class="invalid-feedback">
                          @if (f["email"].errors["required"]) {
                            <div class="text-danger">Email is required</div>
                          }
                          @if (f["email"].errors["pattern"]) {
                            <div class="text-danger">Email is not Valid</div>
                          }
                        </div>
                      }
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        for="phone_number"
                        class="form-label mandatoryLabel"
                        [ngClass]="{
                          'is-invalid': submitted && f['phone_number'].errors,
                        }"
                        >Phone Number
                        <i class="fa-solid fa-asterisk mandatoryIcon"></i
                      ></label>
                      <app-phone-number-input
                        #phoneComp
                        formControlName="phone_number"
                        [isInvalid]="
                          (submitted || f['phone_number'].touched) &&
                          !!f['phone_number'].errors
                        "
                        [parentErrors]="f['phone_number'].errors"
                        defaultCountry="US"
                        >></app-phone-number-input
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        for="apps"
                        class="form-label mandatoryLabel"
                        [ngClass]="{
                          'is-invalid': submitted && f['apps'].errors,
                        }"
                        >Allowed Apps
                        <i class="fa-solid fa-asterisk mandatoryIcon"></i>
                      </label>

                      <ng-select
                        placeholder="Select"
                        [multiple]="true"
                        formControlName="apps"
                        name="apps"
                        [compareWith]="compareApps"
                        class="transcribeClass"
                      >
                        @for (app of allApps; track app.id) {
                          <ng-option [value]="app.id">{{ app.name }}</ng-option>
                        }
                      </ng-select>

                      @if (submitted && f["apps"].errors) {
                        <div class="invalid-feedback">
                          @if (f["apps"].errors["required"]) {
                            <div class="text-danger">Apps is required</div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="d-flex text-end mt-3">
                    <button
                      class="btn btn-light cancelBtn"
                      type="button"
                      (click)="pressCancel()"
                      (keydown.enter)="pressCancel()"
                    >
                      Cancel
                    </button>
                    @if (userselectedId == null) {
                      <button
                        class="btn btn-primary updateBtn"
                        type="submit"
                        [disabled]="spinner"
                        (click)="onSubmit()"
                        (keydown.enter)="onSubmit()"
                      >
                        Save
                      </button>
                    }
                    @if (userselectedId != null) {
                      <button
                        class="btn btn-primary updateBtn"
                        type="submit"
                        [disabled]="spinner"
                        (click)="onSubmit()"
                        (keydown.enter)="onSubmit()"
                      >
                        Update
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</app-dialog-modal>
